import { useContext, useRef } from "react";
import style from "../../../PennyDrop/PennyDrop.module.css";

// * Components
import TextInputField from "../../../../DataInputFields/TextInputField/TextInputField";
import ContinueButton from "../../../../Buttons/SlideContinueButton/ContinueButton";

// * Constants
import * as Errors from "../../../../../utils/errors";

import ErrorContext from "../../../../../context/ErrorProvider";
import { isBlank } from "../../../../../helpers";

export default function ProjectDetails({
  updateJourneyData,
  switchToNextSlide,
  loading,
  validatePinCode,
  validateCityAndState,
}) {
  const developerNameRef = useRef();
  const projectNameRef = useRef();
  const pincodeRef = useRef();
  const cityRef = useRef();
  const stateRef = useRef();
  const otherRef = useRef();

  const { error, setError, resetError } = useContext(ErrorContext);

  const validateBlankField = (value, errorType) => {
    if (isBlank(value)) {
      setError({
        error: true,
        type: errorType,
        message: Errors.REQUIRED_FIELD,
      });
      return false;
    } else {
      if (error.error && error.type === errorType) resetError();
      return true;
    }
  };

  const getFieldsValues = () => {
    const developerName = developerNameRef.current.value;
    const projectName = projectNameRef.current.value;
    const pincode = pincodeRef.current.value;
    const city = cityRef.current.value;
    const state = stateRef.current.value;
    const other = otherRef.current.value;

    return {
      developerName,
      projectName,
      pincode,
      city,
      state,
      other,
    };
  };
  const validateFields = (value, name) => {
    let isValid;
    switch (name) {
      case "developerName":
        isValid = validateBlankField(value, Errors.PROJECT_DEVELOPER_NAME);
        break;
      case "projectName":
        isValid = validateBlankField(value, Errors.PROJECT_NAME);
        break;
      case "city":
        isValid = validateCityAndState(value, Errors.PROJECT_CITY);
        break;
      case "state":
        isValid = validateCityAndState(value, Errors.PROJECT_STATE);
        break;
      case "pincode":
        isValid = validatePinCode(
          value,
          Errors.PROJECT_PINCODE,
          pincodeRef,
          cityRef,
          stateRef
        );
        break;
      default:
        isValid = true;
    }

    return isValid;
  };

  const handleSubmit = async () => {
    const projectDetailss = getFieldsValues();
    const fields = Object.keys(projectDetailss);
    let isValid;
    for (let i = 0; i < fields.length; i++) {
      isValid = validateFields(projectDetailss[fields[i]], fields[i]);
      if (!isValid) break;
    }

    if (isValid) {
      const slidePayload = {
        slideName: "Home Loan Sanction Letter",
        slideIndex: 48,
        slideIcon: "HomeLoanSanctionLetter",
      };
      const data = {
        project_builder_name: projectDetailss.developerName,
        project_name: projectDetailss.projectName,
        project_pincode: projectDetailss.pincode,
        project_city: projectDetailss.city,
        project_state: projectDetailss.state,
        project_other_info: projectDetailss.other,
      };
      await updateJourneyData(data, slidePayload);

      switchToNextSlide();
    }
  };

  return (
    <div className={style.slide}>
      <div className={style.slideHeader}>
        <h1>Project Details</h1>
        <p>Please enter your project details.</p>
      </div>

      <div className={style.inputFieldBox}>
        <TextInputField
          type="text"
          label="Developer Name"
          placeholder="Developer Name"
          name="developerName"
          id="developerName"
          reference={developerNameRef}
          handler={validateFields}
          error={error}
          errorType={Errors.PROJECT_DEVELOPER_NAME}
          required={true}
        />
        <TextInputField
          type="text"
          label="Project Name"
          placeholder="Project Name"
          name="projectName"
          id="projectName"
          reference={projectNameRef}
          handler={validateFields}
          error={error}
          errorType={Errors.PROJECT_NAME}
          required={true}
        />
        <TextInputField
          type="text"
          label="Pincode"
          placeholder="Pincode"
          name="pincode"
          id="pincode"
          reference={pincodeRef}
          handler={validateFields}
          error={error}
          errorType={Errors.PROJECT_PINCODE}
          required={true}
        />
        <TextInputField
          type="text"
          label="City"
          placeholder="City"
          name="city"
          id="city"
          reference={cityRef}
          handler={validateFields}
          error={error}
          errorType={Errors.PROJECT_CITY}
          required={true}
        />
        <TextInputField
          type="text"
          label="State"
          placeholder="State"
          name="state"
          id="state"
          reference={stateRef}
          handler={validateFields}
          error={error}
          errorType={Errors.PROJECT_STATE}
          required={true}
        />
        <TextInputField
          type="text"
          label="Other"
          placeholder="Other"
          name="other"
          id="other"
          reference={otherRef}
          handler={validateFields}
          error={error}
          errorType={Errors.IFSC_CODE_ERROR_TYPE}
        />
      </div>

      <div>
        <ContinueButton
          loading={loading}
          label="Continue"
          disabled={error.error}
          handler={handleSubmit}
        />
      </div>
    </div>
  );
}
